import { render, staticRenderFns } from "./keyWordSet.vue?vue&type=template&id=0c9cdc4c&scoped=true&"
import script from "./keyWordSet.vue?vue&type=script&lang=js&"
export * from "./keyWordSet.vue?vue&type=script&lang=js&"
import style0 from "./keyWordSet.vue?vue&type=style&index=0&id=0c9cdc4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9cdc4c",
  null
  
)

export default component.exports